<template>
  <div class="chre-box">
    <div class="pic-ab chend1">
      <img src="../../../assets/aboutus/qiezhiji.jpg" alt />
      <div class="head">
        <span class="jiacu">国望全自动高速切纸生产线</span>
        <div class="txt">
          <div class="p">
            <span class="tia">介绍:</span>
            <span class="feng">高性价比、高性能切纸机,配置15英寸触摸屏,国际知名品牌电控设备，为机器稳定高效的运行提供了全面保障。</span>
          </div>
          <div class="p p-2">
            <span class="tia">用途:</span>
            <span class="feng one">开白料、切成品</span>
          </div>
        </div>
      </div>
    </div>

    <div class="pic-ab">
      <img src="../../../assets/aboutus/yinshua.jpg" alt />
      <div class="head">
        <span class="jiacu">海德堡XL-1050五色胶印机</span>
        <div class="txt">
          <div class="p">
            <span class="tia">介绍:</span>
            <span class="feng">
              时速18000 配备CP窗控制系统及原厂酒精润版系统 自动装版 CP2000 传纸滚筒气垫 图文控制功能
              预设置 加强型飞达 钢板纸堆 吸气皮带飞达 水箱制冷和循环功能 电子双张检测
              遥控套准和对角线套准 自动清洗 在线统供墨系 加型强收纸 红外干燥之星系统。
            </span>
          </div>
          <div class="p p-2">
            <span class="tia">用途:</span>
            <span class="feng one">印刷</span>
          </div>
        </div>
      </div>
    </div>

    <div class="pic-ab">
      <img src="../../../assets/aboutus/fumo.jpg" alt />
      <div class="head">
        <span class="jiacu">康得新全自动覆膜机</span>
        <div class="txt">
          <div class="p">
            <span class="tia">介绍:</span>
            <span
              class="feng"
            >热压锟采用内油加温系统，温度高、恒温效果好，达到覆膜质量要求。具有电动液压，胶锟冷却机构。配合“节能环保型预涂膜”而生产的专用于预涂膜复合加工的新设备。</span>
          </div>
          <div class="p p-2">
            <span class="tia">用途:</span>
            <span class="feng one">覆膜</span>
          </div>
        </div>
      </div>
    </div>

    <div class="pic-ab">
      <img src="../../../assets/aboutus/tangjin.jpg" alt />
      <div class="head">
        <span class="jiacu">国望全自动烫金机</span>
        <div class="txt">
          <div class="p">
            <span class="tia">介绍:</span>
            <span
              class="feng"
            >高品质台湾制飞达，4吸盘吸纸，4吸盘送纸，确保稳定快速送纸。纵向全幅面送箔系统，可纵向横向同时烫金，减少用箔量并节省换箔时间。美国进口同步带，保证宽泛的速度选择和巨大的承载力，无需维护，使用寿命长。</span>
          </div>
          <div class="p p-2">
            <span class="tia">用途:</span>
            <span class="feng one">烫金、模切、深压纹、激凸、压凹</span>
          </div>
        </div>
      </div>
    </div>

    <div class="pic-ab">
      <img src="../../../assets/aboutus/moqieji.jpg" alt />
      <div class="head">
        <span class="jiacu">胜利全自动模切机</span>
        <div class="txt">
          <div class="p">
            <span class="tia">介绍:</span>
            <span class="feng">具有一次清废系统，它能在模切生产的同时，排除其所有（除叼纸边外）与包装盒无关的纸屑和废边。高精度间歇机构，机器运转平稳。</span>
          </div>
          <div class="p p-2">
            <span class="tia">用途:</span>
            <span class="feng one">模切、激凸、压凹</span>
          </div>
        </div>
      </div>
    </div>

    <div class="pic-ab no">
      <img src="../../../assets/aboutus/zhedie.jpg" alt />
      <div class="head">
        <span class="jiacu">全自动糊袋生产线</span>
        <div class="txt">
          <div class="p">
            <span class="tia">介绍:</span>
            <span class="feng"></span>
          </div>
          <div class="p p-2">
            <span class="tia">用途:</span>
            <span class="feng one">折叠成型</span>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.chre-box {
  margin-top: 40px;
  background: #fff;
  padding: 30px;
  box-sizing: border-box;
  .pic-ab {
    width: 100%;
    display: flex;
    border-bottom: 1px dashed #ddd;
    padding: 20px 0;
    box-sizing: border-box;
    img {
      width: 240px;
      height: 180px;
    }
    .head {
      margin-left: 10px;
      span {
        color: #666666;
      }
      .jiacu {
        font-weight: bold;
        font-size: 16px;
      }
      .txt {
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 24px;
        color: #666666;
        margin-top: 10px;
        .p {
          display: flex;
          span.tia {
            width: 40px;
          }
          span {
            font-size: 14px;
            display: block;
          }
          span.feng {
            width: 600px;
            display: -webkit-box;

            -webkit-box-orient: vertical;

            -webkit-line-clamp: 5;

            overflow: hidden;
          }
          .one {
            color: red;
          }
        }
        .p-2{
          margin-top: 4px;
        }
      }
      margin-bottom: 9px;
    }
  }
  .chend1 {
    padding-top: 0;
  }
  .no {
    padding-bottom: 0;
    border-bottom: none;
  }
}
</style>